import { useTranslation } from 'react-i18next';

export default function MapSection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-10">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('access.map.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('access.map.title')}
          </h2>
          <p className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">
            {t('access.map.titleEn')}
          </p>
          <div className="gold-line mx-auto"></div>
        </div>

        <div className="w-full aspect-[16/9] overflow-hidden border border-background-200/60">
          <iframe
            title={t('access.map.title')}
            src={`https://maps.google.com/maps?q=${encodeURIComponent(
              '東京都江東区青海2-7-4',
            )}&z=16&hl=ja&output=embed`}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="w-full h-full"
          ></iframe>
        </div>

        <p className="text-[14px] text-accent-600 tracking-[0.05em] text-center mt-5 font-medium">
          {t('access.map.note')}
        </p>
      </div>
    </section>
  );
}
